import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const withdrawList = createAsyncThunk(
  "withdrawList",
  async (payload, thunkAPI) => {
    try {
    
      const response = await api.get("withdrawal");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const withdrawListSlice = createSlice({
  name: "withdrawList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(withdrawList.pending, (state) => {
        state.loading = true;
      })
      .addCase(withdrawList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(withdrawList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default withdrawListSlice.reducer;
